import { render, staticRenderFns } from "./CheckUpForm.vue?vue&type=template&id=7b4b8f8d&"
import script from "./CheckUpForm.vue?vue&type=script&lang=js&"
export * from "./CheckUpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports